import { ArrowUpRight } from "lucide-react";
import { Chapter, FadeIn } from "./Reveal";
import { IMAGES, PRODUCTS } from "../data/site";

export const Products = () => (
    <section
        id="products"
        data-testid="products-section"
        className="border-t border-line bg-coal/40 py-28 md:py-40"
    >
        <div className="mx-auto max-w-screen-2xl px-6 md:px-12">
            <Chapter number="03" label="Products" />
            <div className="mb-14 flex flex-wrap items-end justify-between gap-6 md:mb-20">
                <FadeIn>
                    <h2 className="max-w-3xl font-display text-4xl uppercase leading-[0.95] tracking-tight text-zinc-100 md:text-6xl">
                        Components that <span className="text-ember">earn their steel</span>
                    </h2>
                </FadeIn>
                <FadeIn delay={0.1}>
                    <p className="max-w-sm font-mono text-[10px] uppercase leading-relaxed tracking-[0.2em] text-zinc-500 md:text-xs">
                        Forged, cast and machined to print — for OEM and replacement
                        markets
                    </p>
                </FadeIn>
            </div>
            <div className="grid gap-px border border-line bg-line sm:grid-cols-2 lg:grid-cols-3">
                {PRODUCTS.map((p, i) => (
                    <FadeIn
                        key={p.name}
                        delay={(i % 3) * 0.08}
                        className="group relative bg-ink"
                    >
                        <div
                            data-testid={`product-card-${p.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                            className="p-6 md:p-8"
                        >
                            <div className="relative mb-6 aspect-[4/3] overflow-hidden border border-line">
                                <img
                                    src={IMAGES[p.image]}
                                    alt={p.name}
                                    className={`h-full w-full object-cover grayscale transition-all duration-700 group-hover:scale-105 group-hover:grayscale-0 ${p.pos}`}
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-ink/80 via-transparent to-transparent" />
                                <span className="absolute left-3 top-3 font-mono text-[10px] tracking-[0.3em] text-zinc-400">
                                    P.{String(i + 1).padStart(2, "0")}
                                </span>
                                <ArrowUpRight
                                    size={18}
                                    className="absolute right-3 top-3 text-zinc-500 opacity-0 transition-all duration-300 group-hover:text-ember group-hover:opacity-100"
                                />
                            </div>
                            <h3 className="font-display text-2xl uppercase tracking-tight text-zinc-100 transition-colors group-hover:text-ember">
                                {p.name}
                            </h3>
                            <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500 md:text-xs">
                                {p.spec}
                            </p>
                        </div>
                        <span className="absolute inset-x-0 bottom-0 h-0.5 origin-left scale-x-0 bg-ember transition-transform duration-500 group-hover:scale-x-100" />
                    </FadeIn>
                ))}
            </div>
        </div>
    </section>
);
